import { memo, useCallback, useState } from 'react';
import { FormBuilderCardWrapper } from '../../../FormBuilderCardWrapper';
import {
  useFormBuilderFields,
  useFormBuilderFieldWithError,
} from '../../../hooks';
import { TextEditor } from '@/features/TextEditor';
import { EFormBuilderFieldType, TFormBuilderTextField } from '@/types';

type TProps = {
  field: TFormBuilderTextField;
  index: number;
};

export const FormBuilderText =
  /**
   * Rich text field component for form builder with text editor
   * @param {TProps} props - Component props
   * @param {TFormBuilderTextField} props.field - Text field data
   * @param {number} props.index - Field index in the form
   * @returns {JSX.Element} Form builder text field component with editor
   */
  memo(({ field, index }: TProps) => {
    const [active, setActive] = useState(false);
    const onActiveChange = useCallback(
      (value: boolean) => setActive(value),
      [],
    );

    const error = useFormBuilderFieldWithError<TFormBuilderTextField>(index);

    const { changeFields, removeField, copyField, moveDownField, moveUpField } =
      useFormBuilderFields(field);

    return (
      <FormBuilderCardWrapper
        variant={EFormBuilderFieldType.TEXT}
        active={active}
        onActiveChange={onActiveChange}
        onRemove={removeField}
        onDownMove={moveDownField}
        onUpMove={moveUpField}
        onDuplicate={copyField}
        error={!!error}
      >
        <TextEditor
          value={field.text}
          error={!!error?.text}
          onChange={(text) => changeFields({ text })}
        />
      </FormBuilderCardWrapper>
    );
  });

FormBuilderText.displayName = 'FormBuilderText';
